// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#video-preview {\n  width: 100vw !important;\n  height: calc(var(--vh) * 100) !important;\n  z-index: 3000;\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: black;\n}\n", ""]);
// Exports
module.exports = exports;
